import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaiairportreturncab() {



  const cardData = {


  keyword: "Pune to Mumbai Airport Return Cab",

  headingDescription: "Trustline Cab offers dependable Pune to Mumbai Airport Return Cab services with safe, comfortable, and affordable round-trip transportation for domestic and international travelers. Whether you are traveling for business meetings, family vacations, corporate tours, medical appointments, or airport transfers, our professional chauffeurs ensure timely pickups, flight-friendly scheduling, and a hassle-free return journey. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent round-trip pricing, doorstep pickup, easy online booking, flexible waiting options, and 24/7 customer support, Trustline Travels is your trusted choice for Pune to Mumbai Airport return taxi services.",

  topPlaces: [
    {
      title: "Chhatrapati Shivaji Maharaj International Airport",
      description: "Mumbai's primary international airport is one of India's busiest aviation hubs, serving millions of domestic and international passengers every year. Equipped with world-class facilities, premium lounges, shopping outlets, and seamless connectivity, it is the preferred gateway for business and leisure travelers."
    },
    {
      title: "Terminal 2 (T2)",
      description: "Terminal 2 is Mumbai Airport's award-winning international terminal, offering luxurious passenger lounges, premium retail stores, fine dining options, modern immigration facilities, and excellent connectivity to destinations across the globe."
    },
    {
      title: "Terminal 1 (T1)",
      description: "Terminal 1 handles domestic flights for major airlines and provides modern passenger amenities, efficient boarding facilities, shopping outlets, restaurants, and convenient road connectivity for travelers arriving from or departing to cities across India."
    },
    {
      title: "Airport Road",
      description: "Airport Road is a major commercial corridor connecting Mumbai Airport with business districts, hotels, metro stations, and important city destinations. It offers quick access for corporate travelers, tourists, and airport transfer passengers."
    },
    {
      title: "Marol Naka",
      description: "Marol Naka is a busy commercial locality located close to Mumbai Airport, featuring business hotels, corporate offices, metro connectivity, restaurants, and excellent transportation links. It is a preferred destination for professionals and frequent flyers."
    },
    {
      title: "MIDC Andheri",
      description: "MIDC Andheri is a leading industrial and commercial zone housing IT companies, manufacturing units, engineering firms, and corporate offices. Its proximity to the airport makes it an important destination for business travelers."
    },
    {
      title: "Jio World Convention Centre",
      description: "Jio World Convention Centre is one of India's largest convention venues, hosting international exhibitions, corporate conferences, product launches, business summits, and prestigious events throughout the year."
    },
 
  ],






"services": [
  {
    "name": "Pune to Mumbai Airport Return Cab",
    "description": "Book Pune to Mumbai Airport Return Cab for comfortable round-trip airport travel with professional chauffeurs, clean AC vehicles, transparent pricing, doorstep pickup, flexible return schedules, and 24x7 customer support. Choose Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles for family travel, business trips, corporate airport transfers, and convenient same-day or scheduled return journeys."
  },
  {
    "name": "Pune to Mumbai Airport Round Trip Cab",
    "description": "Choose Pune to Mumbai Airport Round Trip Cab for reliable airport transportation with experienced drivers, sanitized vehicles, fixed fares, spacious luggage capacity, comfortable seating, and flexible return timing. Perfect for family vacations, corporate travel, business meetings, international flights, and domestic airport transfers."
  },
  {
    "name": "Pune to Mumbai Airport Return Taxi",
    "description": "Book Pune to Mumbai Airport Return Taxi with affordable pricing, professional drivers, premium AC vehicles, safe highway travel, and dependable pickup and return service for business travelers, families, students, and tourists."
  },
  {
    "name": "Pune to Mumbai Airport Cab Service",
    "description": "Our Pune to Mumbai Airport Cab Service offers one-way and return airport transportation with punctual pickup, chauffeur-driven vehicles, transparent pricing, comfortable travel, and reliable customer support for domestic and international airport transfers."
  },
  {
    "name": "Pune to Mumbai Airport Taxi Service",
    "description": "Reserve Pune to Mumbai Airport Taxi Service with experienced chauffeurs, well-maintained AC cars, affordable fares, on-time airport transfers, and comfortable travel for corporate, family, and personal journeys."
  },
  {
    "name": "Pune to Mumbai Airport Cab Booking",
    "description": "Complete your Pune to Mumbai Airport Cab Booking with instant confirmation, multiple vehicle options, fixed pricing, doorstep pickup, professional drivers, and secure online reservation for hassle-free airport transportation."
  },
  {
    "name": "Book Pune to Mumbai Airport Return Cab",
    "description": "Book Pune to Mumbai Airport Return Cab anytime for convenient airport pickup and drop service with Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles, offering affordable fares and reliable chauffeur-driven transportation."
  },
  {
    "name": "Online Pune to Mumbai Airport Cab Booking",
    "description": "Use Online Pune to Mumbai Airport Cab Booking to reserve your airport taxi quickly with instant confirmation, secure booking process, transparent pricing, and professional drivers available 24x7."
  },
  {
    "name": "Pune to Mumbai Airport Pickup and Drop",
    "description": "Choose Pune to Mumbai Airport Pickup and Drop service for reliable airport transfers with comfortable AC vehicles, experienced chauffeurs, timely pickup, flexible scheduling, and safe highway travel."
  },
  {
    "name": "Pune to Mumbai Airport Two Way Cab",
    "description": "Book Pune to Mumbai Airport Two Way Cab for complete round-trip airport travel with flexible return timing, affordable fares, premium vehicles, and professional drivers for a smooth travel experience."
  },
  {
    "name": "Pune to Mumbai Airport Return Trip Cab",
    "description": "Reserve Pune to Mumbai Airport Return Trip Cab with comfortable chauffeur-driven vehicles, fixed pricing, doorstep pickup, luggage assistance, and dependable return transportation for families, professionals, and tourists."
  },
  {
    "name": "Pune to Mumbai Airport Travel Cab",
    "description": "Book Pune to Mumbai Airport Travel Cab for business travel, corporate airport transfers, family vacations, holiday trips, and personal travel with clean AC vehicles and experienced drivers."
  },
  {
    "name": "Pune to Mumbai Airport Private Cab",
    "description": "Choose Pune to Mumbai Airport Private Cab for exclusive chauffeur-driven travel with flexible pickup timing, complete privacy, comfortable seating, premium vehicles, and safe intercity transportation."
  },
  {
    "name": "Pune to Mumbai Airport AC Cab",
    "description": "Travel comfortably with Pune to Mumbai Airport AC Cab featuring well-maintained air-conditioned vehicles, experienced drivers, affordable fares, spacious luggage space, and smooth airport connectivity."
  },
  {
    "name": "Pune to Mumbai Airport Intercity Cab",
    "description": "Our Pune to Mumbai Airport Intercity Cab service provides safe, reliable, and affordable long-distance transportation with professional chauffeurs, premium vehicles, transparent fares, and punctual service."
  },
  {
    "name": "Pune to Mumbai Airport Car Rental",
    "description": "Choose Pune to Mumbai Airport Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles for airport transfers, business travel, corporate transportation, and family trips."
  },
  {
    "name": "Pune to Mumbai Airport Same Day Return Cab",
    "description": "Book Pune to Mumbai Airport Same Day Return Cab with flexible return timing, experienced drivers, clean AC vehicles, transparent pricing, and convenient airport transportation without overnight charges."
  },
  {
    "name": "Pune to Mumbai Airport Cab Hire",
    "description": "Hire Pune to Mumbai Airport Cab with professional chauffeurs, comfortable AC vehicles, affordable pricing, premium service, and dependable airport transportation for one-day or return travel."
  },
  {
    "name": "Pune to Mumbai Airport Taxi Booking",
    "description": "Complete your Pune to Mumbai Airport Taxi Booking online with instant confirmation, multiple vehicle choices, fixed fares, professional drivers, and reliable airport transfer services."
  },
  {
    "name": "Pune to Mumbai Airport Return Cab Fare",
    "description": "Check Pune to Mumbai Airport Return Cab Fare with transparent pricing, fixed rates, affordable packages, and multiple vehicle options including Sedan, Ertiga, Innova Crysta, SUV, and premium cars."
  }
],

"tableData": [
  ["Pune to Mumbai Airport Return Cab", "Pune to Mumbai Airport Round Trip Cab"],
  ["Pune to Mumbai Airport Return Taxi", "Pune to Mumbai Airport Cab Service"],
  ["Pune to Mumbai Airport Taxi Service", "Pune to Mumbai Airport Cab Booking"],
  ["Book Pune to Mumbai Airport Return Cab", "Online Pune to Mumbai Airport Cab Booking"],
  ["Pune to Mumbai Airport Pickup and Drop", "Pune to Mumbai Airport Two Way Cab"],
  ["Pune to Mumbai Airport Return Trip Cab", "Pune to Mumbai Airport Travel Cab"],
  ["Pune to Mumbai Airport Private Cab", "Pune to Mumbai Airport AC Cab"],
  ["Pune to Mumbai Airport Intercity Cab", "Pune to Mumbai Airport Car Rental"],
  ["Pune to Mumbai Airport Same Day Return Cab", "Pune to Mumbai Airport Cab Hire"],
  ["Pune to Mumbai Airport Taxi Booking", "Pune to Mumbai Airport Return Cab Fare"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Pune to Mumbai Airport Return Cab",
    WhyChoosedescription: "Trustline Cab offers dependable Pune to Mumbai Airport return cab services with flexible schedules for domestic and international travelers."
  },
  {
    WhyChooseheading: "Round-Trip Airport Transfers",
    WhyChoosedescription: "Book a return cab for both airport drop and pickup, making your complete journey convenient, comfortable, and hassle-free."
  },
  {
    WhyChooseheading: "Punctual Airport Pickup & Drop",
    WhyChoosedescription: "Our chauffeurs monitor your travel schedule and ensure timely airport transfers, helping you avoid unnecessary delays."
  },
  {
    WhyChooseheading: "Premium Fleet for Every Traveler",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers with spacious seating and luggage capacity."
  },
  {
    WhyChooseheading: "Transparent Return Cab Pricing",
    WhyChoosedescription: "Receive detailed fare quotations with competitive pricing and no hidden charges for your airport return booking."
  },
  {
    WhyChooseheading: "Pickup from Any Location in Pune",
    WhyChoosedescription: "Doorstep pickup is available from homes, offices, hotels, Pune Airport, Pune Railway Station, and all major areas across Pune."
  },
  {
    WhyChooseheading: "Ideal for Business & Family Travel",
    WhyChoosedescription: "Our return airport cab service is suitable for corporate executives, families, tourists, students, and frequent flyers."
  },
  {
    WhyChooseheading: "Easy Booking with 24/7 Customer Support",
    WhyChoosedescription: "Book your Pune to Mumbai Airport return cab anytime with instant confirmation and dedicated travel assistance."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Pune to Mumbai Airport return cab service?",
    answer: "Yes, Trustline Cab offers reliable return cab services between Pune and Mumbai Airport for domestic and international travelers."
  },
  {
    question: "Can I book both airport drop and return pickup together?",
    answer: "Yes, you can reserve a complete round-trip airport transfer with both departure and return journeys in a single booking."
  },
  {
    question: "Do you provide airport transfers to Terminal 1 and Terminal 2?",
    answer: "Yes, we provide return cab services to and from both Mumbai Airport Terminal 1 and Terminal 2."
  },
  {
    question: "Which vehicles are available for airport return travel?",
    answer: "We offer Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers to suit different passenger and luggage requirements."
  },
  {
    question: "Can I schedule my return pickup according to my flight arrival?",
    answer: "Yes, your return pickup can be scheduled according to your flight timing for a convenient airport transfer experience."
  },
  {
    question: "Are toll and parking charges included in the return cab fare?",
    answer: "Toll charges, parking fees, airport parking, and applicable taxes are generally charged separately unless specifically mentioned in your booking quotation."
  },
  {
    question: "Is Pune to Mumbai Airport return cab service available 24/7?",
    answer: "Yes, our airport return cab service operates 24 hours a day for early morning, daytime, and late-night flights."
  },
  {
    question: "Should I reserve my return airport cab in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and timely airport transfers."
  },
  {
    question: "Is this service suitable for corporate and family travelers?",
    answer: "Yes, our return airport cab service is ideal for business professionals, families, tourists, students, and frequent travelers."
  },
  {
    question: "How can I book a Pune to Mumbai Airport Return Cab with Trustline Travels?",
    answer: "Simply share your pickup address, flight details, travel dates, passenger count, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Deshpande",
    feedback: "The return airport transfer was managed flawlessly from start to finish. Every timing was perfectly coordinated, and the comfortable vehicle made both journeys between Pune and Mumbai Airport completely stress-free.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Shruti Kulshreshtha",
    feedback: "Trustline Travels delivered a seamless round-trip airport travel experience with professional service, courteous drivers, and excellent communication. The convenience of having both transfers arranged in advance was truly valuable.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Airport Return Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/pune-to-mumbai-airport-return-cab.webp",
  "description": "Book Pune to Mumbai Airport return cab service with Trustline Travels for comfortable and reliable round-trip airport travel. Get affordable return taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6185"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/pune-to-mumbai-airport-return-cab"
  }
};






  return (
    <div>
<Helmet>
  <title>Pune to Mumbai Airport Return Cab | Round Trip Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Pune to Mumbai Airport return cab with Trustline Travels for safe and comfortable round-trip airport transfers. Get reliable Sedan, Ertiga, SUV, Innova, and Innova Crysta taxi services with 24x7 availability."
  />

  <meta
    name="keywords"
    content="Pune to Mumbai Airport Return Cab, Pune to Mumbai Airport Round Trip Cab, Pune to Mumbai Airport Return Taxi, Pune to Mumbai Airport Cab Service, Pune Mumbai Airport Return Taxi, Pune to Mumbai Airport Pickup Drop Cab, Pune Mumbai Airport Round Trip Taxi, Pune Mumbai Airport Innova Cab, Pune Mumbai Airport Return Cab Booking, Pune Airport to Mumbai Airport Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/80.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaiairportreturncab;